import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model'; 
import { Level } from '@ascschool/model/category/level.model'; 
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter'; 
import { MinistryOfEducationAndTraining } from '@ascschool/model/organization/ministry-of-education-and-training.model';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';  
import { MinistryOfEducationAndTrainingService } from '@ascschool/services/organization/ministry-of-education-and-training.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';  
import { PopUpTrungTamGDDBComponent } from './pop-up-trung-tam-gddb/pop-up-trung-tam-gddb.component';
import { ThemTrungTamGDDBComponent } from './them-trung-tam-gddb/them-trung-tam-gddb.component'; 
import { XemTrungTamGDDBComponent } from './xem-trung-tam-gddb/xem-trung-tam-gddb.component';
@Component({
  selector: 'app-trung-tam-gddb',
  templateUrl: './trung-tam-gddb.component.html',
  styleUrls: ['./trung-tam-gddb.component.scss']
})
export class TrungTamGDDBComponent implements OnInit, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  heightModal: string;
  widthModal: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  listGDDB: MinistryOfEducationAndTraining[];
  listGDDBSelected: number[];
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: MinistryOfEducationAndTraining[] = [];
  setOfCheckedId = new Set<number>();
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    private authQuery: AuthQuery,
    private service: MinistryOfEducationAndTrainingService,
    public utilService: UtilsService
  ) { }
  get breadcrumbs(): string[] {
    return ['Quản lý đơn vị'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  categoryModel = new CategoryModel();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  listData: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef; 
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;

  sortNameFn = (a: Level, b: Level) => a.levelName.localeCompare(b.levelName);
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.reload();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe((item) => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  reload() {
    this.loading = true;
    this.checked = false;
    this.service.getAll(this.commonFilter).subscribe((response: any) => {
      this.Total = response.rowCount;
      this.firstRowOnPage = response.firstRowOnPage;
      this.listData = response.results ? response.results : [];
      this.loading = false;
      this.listData.map(x => x.checked = false);
      this.listGDDBSelected = [];
    }, (err: any) => {
      this.listData = [];
      this.listGDDBSelected = [];
      this.loading = false;
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => this.add(),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void { }

  //popup 
  add() {
    this.isResizdePopup = false;
    this.titlePopup = 'Thêm mới - thông tin Trung Tâm Giáo Dục Đặt Biệt Quốc Gia';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ThemTrungTamGDDBComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal,
      },
      nzComponentParams: { 
        dataTransmission: null
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }

  edit(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Chỉnh sửa - thông tin Trung Tâm Giáo Dục Đặt Biệt Quốc Gia';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpTrungTamGDDBComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal,
      },
      nzComponentParams: {
        dataTransmission: item.id
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }
  view(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Xem - thông tin Trung Tâm Giáo Dục Đặt Biệt Quốc Gia';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: XemTrungTamGDDBComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal,
      },
      nzComponentParams: {
        dataTransmission: item.id
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }
  deleteMulti(): void {
    this.listGDDBSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listGDDBSelected.push(item);
    });
    if (this.listGDDBSelected.length > 0) {
    const dialogRef = this.modalService.create({
      nzTitle: 'Xóa Trung Tâm Giáo Dục Đặt Biệt Quốc Gia',
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: 'Trung Tâm Giáo Dục Đặt Biệt Quốc Gia đã chọn'
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false,
    });
    dialogRef.afterClose.subscribe(results => {
      if (results) {
        this.service.deleteMulti(this.listGDDBSelected).subscribe((res: any) => {
          this.msg.success('Cập nhật thông tin ' + res.message);
          this.reload();
        });
      }
    });
  } else {
    this.msg.warning('Bạn chưa chọn dữ liệu cần xóa');
  }
  }
  
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  clear() {
    delete this.commonFilter.EducationAndTrainingCode;
    delete this.commonFilter.EducationAndTrainingName;
    delete this.commonFilter.Director;
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height = this.heightModal;
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: { 
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: height,
        height: height,
      }
    });
  }
}
